import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { trackEventPageView, trackPortfolioPageView } from '@utils/analytics';
import { useTranslation } from 'react-i18next';

export const usePageTracking = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    // Track page view
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });

    // Track specific page types based on URL patterns
    const pathname = location.pathname;
    
    // Get the translated URL patterns
    const eventsUrl = t('events-url');
    const portfoliosUrl = t('portfolios-url');
    
    // Check if it's an event page (contains /events/ in the path)
    const eventMatch = pathname.match(new RegExp(`${eventsUrl.replace('/', '\\/')}\\/([^\\/]+)`));
    if (eventMatch) {
      trackEventPageView(eventMatch[1]);
    }

    // Check if it's a portfolio page (contains /portfolios/ in the path)
    const portfolioMatch = pathname.match(new RegExp(`${portfoliosUrl.replace('/', '\\/')}\\/([^\\/]+)`));
    if (portfolioMatch) {
      trackPortfolioPageView(portfolioMatch[1]);
    }
  }, [location, t]);
}; 